export const SERVER_ERROR = 'Something went wrong!';
export const ESC_KEY = 27;
export const LEFT_ARROW = 37;
export const RIGHT_ARROW = 39;
export const INITIAL_TOAST_MESSAGE = { message: '', messageType: 'neutral' };
export const LOCLIZATION_STRAPI = 'https://strapi.bellabona.com/localization';
export const EMPTY_MENU_MESSAGE_STRAPI = 'https://strapi.bellabona.com/empty-menu-message';
